import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./secondpage.css";

const SecondPage = () => {
 const navigate = useNavigate();

 const handleClick = () => {
    navigate("/thirdPage");
 };

 const ref = useRef();

 useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries[0].target.classList.remove("hide");
      },
      { threshold: 0.1 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
 }, []);

 return (
    <main ref={ref} className="hide">
      <div className="scrollbar"></div>
      <div className="container">
        <p>

          Heyaa Bacchhaaa.....I LOVE YOU.....and thats something i want to tell
          you...not just you I want to tell this to everyone....har kisi ko ye
          chick chick ke batana chahti hu ki
          m...RISHIKA....tujhe...yanii....
        </p>
        <p>
        MANI se kitna pyar krti hu...itna
          jitna syd kisi ne kabhi ni kiya ho...itna jitna mujhe aaj tk mila
          ho...itna jitna mere pass hai....mene mera pura pyar ka ghada tujhpe
          lutaya hai....Itna pyar kisi se ni kiya....baccha i want to see
          you...and want to take care of yoy....I want to hug you .....baccha i
          want you....I NEED YOU....you are my that land....mano m kisan
          hu....tu jb meri jamin yani land pe kuch ni lagega kuch ni ugega to
          bhala vo khud kya khayega oor kisi or kya dega....
        </p>
        <p>
        to baccha you are my
          that land....jaha se mujhe pyar milta hai or jaise ek kisan ki jama
          punji uska khet hota hai na vese hi tu hai mere liye....meri sari jama
          punji....jisko m kabhi ni kho skti....or jis din vo jgah chin gyi to
          us kisan ka sb kuch chin jayega tu bhi vhi h....jiske bina mera kn ho
          skta....jiske liye mene mehnat ki hai....jaise kisan apni jamin ka
          dhayan rakhta hai....fertilizer khad dal ke usko acha banata
          hai....
        </p>
        <p>
        vese hi mere efforts (chote chote) or pyar se m tujhe sanjona
          chahti hu.....tujhe sb s bacha ke apne karib rakhna chahti hu....tujhe
          protect krna chahti hu....tere 4ro side fence lgana chahti hu....lkn
          sath me tujhe itni jgah dena chahti hu ki jb tera pyar aaye to vo bhi
          behti hawao ke sath un khet ki fasal ke jaise lehra jaye....or m bs
          dekh k hi khus ho jau....baccha I LOVE YOU...
        </p>
      </div>
      <div className="secondbutton">
        <button onClick={handleClick}>
          Go to Third Page
        </button>
      </div>
    </main>
 );
};

export default SecondPage;

